// import the api endpoints
import api from '../api';
const initialState = () => ({
    programs: [],
    students: [],
    currentProgram: {},
    currentStudent: {},
    instructors: [],
    currentInstructor: {},
    mockStudents: [],
    loading: false,
    dataLoading: false,
    programStudents: [],
    programInstructors: [],
    sectionLoading: {
        program: false,
        address: false,
        billing: false,
        instructors: false,
        sessions: false,
    },
    instructorSessionStudents: [],
});

const state = initialState();

const getters = {
    programs: (state) => state.programs,
    currentProgram: (state) => state.currentProgram,
    currentStudent: (state) => state.currentStudent,
    currentInstructor: (state) => state.currentInstructor,
    mockStudents: (state) => state.mockStudents,
    loading: (state) => state.loading,
    dataLoading: (state) => state.dataLoading,
    sectionLoading: (state) => state.sectionLoading,
    instructorSessionStudents: (state) => state.instructorSessionStudents,
    programStudents: (state) => state.programStudents,

    instructors: (state) => state.instructors,
    programInstructors: (state) => state.programInstructors,
    students: (state) => state.students,
};

const actions = {
    reset({ commit }) {
        commit('RESET');
    },
    async getCurrentStudent({ commit }, id) {
        try {
            commit('SET_DATA_LOADING', true);
            let data = await api.getStudent(id);
            commit('SET_CURRENT_STUDENT', data);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
            commit('SET_DATA_LOADING', false);
        }
    },
    async getCurrentProgram({ commit }, id) {
        try {
            commit('SET_LOADING', true);
            let data = await api.getProgram(id);
            commit('SET_CURRENT_PROGRAM', data);
            commit('SET_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
            commit('SET_LOADING', false);
        }
    },
    async getPrograms({ commit }) {
        try {
            commit('SET_LOADING', true);
            let data = await api.getPrograms();
            commit('SET_PROGRAMS', data);
            commit('SET_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async getCurrentInstructor({ commit }, params) {
        try {
            commit('SET_LOADING', true);
            let data = await api.getInstructor(params);
            commit('SET_CURRENT_INSTRUCTOR', data);

            commit('SET_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
            commit('SET_LOADING', false);
        }
    },
    async getInstructors({ commit }) {
        try {
            commit('SET_LOADING', true);
            let data = await api.getInstructors();
            commit('SET_INSTRUCTORS', data);
            commit('SET_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async getMockStudents({ commit }, count) {
        try {
            commit('SET_DATA_LOADING', true);
            let data = await api.getMockStudents(count);
            commit('SET_MOCK_STUDENTS', data);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async getStudents({ commit }, params) {
        try {
            commit('SET_DATA_LOADING', true);
            let data = await api.getStudents(params);
            commit('SET_STUDENTS', data);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async getProgramInstructors({ commit }, params) {
        try {
            commit('SET_DATA_LOADING', true);
            let data = await api.getProgramInstructors(params);
            commit('SET_PROGRAM_INSTRUCTORS', data);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },

    async instructorInviteStudent({ commit, dispatch }, id) {
        try {
            const result = await api.inviteStudent(id);
            if (result.status === 'success') {
                dispatch(
                    'Snackbar/showMessage',
                    {
                        content: result.message,
                        color: 'primary',
                    },
                    { root: true }
                );
            } else {
                dispatch(
                    'Snackbar/showMessage',
                    {
                        content: result.message,
                        color: 'error',
                    },
                    { root: true }
                );
            }
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async instructorAddStudents({ commit, dispatch }, params) {
        try {
            commit('SET_DATA_LOADING', true);
            await api.addStudents(params);
            commit('SET_DATA_LOADING', false);
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Successfully added students.`,
                    color: 'primary',
                },
                { root: true }
            );
            dispatch('getCurrentInstructor', {
                instructorId: state.currentInstructor.id,
                sessionId: params.sessionId,
                programId: state.currentInstructor.program.id,
            });
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },

    async updateProgram({ commit, dispatch }, { id, data }) {
        try {
            commit('SET_SECTION_LOADING', { section: 'program', value: true });
            let program = await api.updateProgram(id, data);
            commit('SET_CURRENT_PROGRAM', program);

            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Saved Program ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );

            commit('SET_SECTION_LOADING', { section: 'program', value: false });
        } catch (error) {
            commit('SET_SECTION_LOADING', { section: 'program', value: false });
            commit('SET_ERROR', error, { root: true });
        }
    },
    async updateProgramAddress({ commit, dispatch }, { id, data }) {
        try {
            commit('SET_SECTION_LOADING', { section: 'address', value: true });
            let program = await api.updateProgram(id, data);
            commit('SET_CURRENT_PROGRAM', program);

            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Saved Program ${name} Address.`,
                    color: 'primary',
                },
                { root: true }
            );

            commit('SET_SECTION_LOADING', { section: 'address', value: false });
        } catch (error) {
            commit('SET_SECTION_LOADING', { section: 'address', value: false });
            commit('SET_ERROR', error, { root: true });
        }
    },
    async updateProgramContact({ commit, dispatch }, { id, data }) {
        try {
            commit('SET_SECTION_LOADING', { section: 'billing', value: true });
            let program = await api.updateProgram(id, data);
            commit('SET_CURRENT_PROGRAM', program);
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Saved Program ${name} Billing Contact.`,
                    color: 'primary',
                },
                { root: true }
            );
            commit('SET_SECTION_LOADING', { section: 'billing', value: false });
        } catch (error) {
            commit('SET_SECTION_LOADING', { section: 'billing', value: false });
            commit('SET_ERROR', error, { root: true });
        }
    },
    // eslint-disable-next-line no-unused-vars
    async createProgram({ commit, dispatch }, data) {
        commit('SET_DATA_LOADING', true);
        try {
            const program = await api.createProgram(data);
            commit('SET_CURRENT_PROGRAM', program);
            commit('SET_DATA_LOADING', false);
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Saved Program ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_DATA_LOADING', false);
            commit('SET_ERROR', error, { root: true });
        }
    },
    // eslint-disable-next-line no-unused-vars
    async createInstructors({ commit, dispatch }, { id, data }) {
        commit('SET_SECTION_LOADING', { section: 'instructors', value: true });
        try {
            await api.createInstructors(id, data);
            const program = await api.getProgram(id);
            commit('SET_CURRENT_PROGRAM', program);
            commit('SET_SECTION_LOADING', {
                section: 'instructors',
                value: false,
            });
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Added Instructors for ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_SECTION_LOADING', {
                section: 'instructors',
                value: false,
            });
            commit('SET_ERROR', error, { root: true });
        }
    },
    // eslint-disable-next-line no-unused-vars
    async inactivateInstructor({ commit, dispatch }, { id, instructorId }) {
        commit('SET_SECTION_LOADING', { section: 'instructors', value: true });
        try {
            await api.inactivateInstructor(instructorId);
            const program = await api.getProgram(id);
            commit('SET_CURRENT_PROGRAM', program);
            commit('SET_SECTION_LOADING', {
                section: 'instructors',
                value: false,
            });
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Instructor Made Inactive for ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_SECTION_LOADING', {
                section: 'instructors',
                value: false,
            });
            commit('SET_ERROR', error, { root: true });
        }
    },
    // eslint-disable-next-line no-unused-vars
    async updateInstructor({ commit, dispatch }, { id, data }) {
        commit('SET_SECTION_LOADING', { section: 'instructors', value: true });
        try {
            await api.updateInstructor(id, data);
            const program = await api.getProgram(id);
            commit('SET_CURRENT_PROGRAM', program);
            commit('SET_SECTION_LOADING', {
                section: 'instructors',
                value: false,
            });
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Updated Instructor for ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_SECTION_LOADING', {
                section: 'instructors',
                value: false,
            });
            commit('SET_ERROR', error, { root: true });
        }
    },

    // eslint-disable-next-line no-unused-vars
    async createSession({ commit, dispatch }, { id, data }) {
        commit('SET_SECTION_LOADING', { section: 'sessions', value: true });
        try {
            await api.createSession(id, data);
            const program = await api.getProgram(id);
            commit('SET_CURRENT_PROGRAM', program);
            commit('SET_SECTION_LOADING', {
                section: 'sessions',
                value: false,
            });
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Created Session for ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_SECTION_LOADING', {
                section: 'sessions',
                value: false,
            });
            commit('SET_ERROR', error, { root: true });
        }
    },

    // eslint-disable-next-line no-unused-vars
    async updateSession({ commit, dispatch }, { id, data }) {
        try {
            commit('SET_SECTION_LOADING', { section: 'sessions', value: true });
            await api.updateSession(id, data);
            const program = await api.getProgram(id);
            commit('SET_CURRENT_PROGRAM', program);
            commit('SET_SECTION_LOADING', {
                section: 'sessions',
                value: false,
            });
            const {
                program: { name = '' },
            } = program;
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Updated Sessions for Program ${name}.`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_SECTION_LOADING', {
                section: 'sessions',
                value: false,
            });
            commit('SET_ERROR', error, { root: true });
        }
    },
    async sendNotification({ commit, dispatch }, payload) {
        try {
            await api.sendNotification(payload);
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Message Sent`,
                    color: 'primary',
                },
                { root: true }
            );
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async getInstructorSessionStudents({ commit }, payload) {
        try {
            commit('SET_DATA_LOADING', true);
            const students = await api.getInstructorSessionStudents(payload);
            commit('SET_INSTRUCTOR_SESSION_STUDENTS', students);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async getProgramStudents({ commit }, programId) {
        try {
            commit('SET_DATA_LOADING', true);
            const students = await api.getProgramStudents(programId);
            commit('SET_PROGRAM_STUDENTS', students);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async graduateStudents({ commit, dispatch }, payload) {
        try {
            commit('SET_DATA_LOADING', true);
            await api.graduateStudents(payload);
            const students = await api.getProgramStudents(payload.programId);
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Graduate status updated`,
                    color: 'primary',
                },
                { root: true }
            );
            commit('SET_PROGRAM_STUDENTS', students);
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
    async resendInvite({ commit, dispatch }, payload) {
        try {
            commit('SET_DATA_LOADING', true);
            // we can reuse API since we are just setting grad status and invoking a registration invite
            await api.graduateStudents(payload);
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Resent graduation invitation`,
                    color: 'primary',
                },
                { root: true }
            );
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },

    async resendInstructorInvite({ commit, dispatch }, instructorId) {
        try {
            commit('SET_DATA_LOADING', true);
            // we can reuse API since we are just setting grad status and invoking a registration invite
            await api.resendInstructorInvite(instructorId);
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Instructor registration invite sent`,
                    color: 'primary',
                },
                { root: true }
            );
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },

    async instructorAssignStudents({ commit, dispatch }, payload) {
        try {
            commit('SET_DATA_LOADING', true);
            const students = await api.instructorAssignStudents(payload);
            commit('SET_INSTRUCTOR_SESSION_STUDENTS', students);
            dispatch(
                'Snackbar/showMessage',
                {
                    content: `Successfully assigned students`,
                    color: 'primary',
                },
                { root: true }
            );
            commit('SET_DATA_LOADING', false);
        } catch (error) {
            commit('SET_ERROR', error, { root: true });
        }
    },
};

const mutations = {
    RESET: (state) => {
        const newState = initialState();
        Object.keys(newState).forEach((key) => {
            state[key] = newState[key];
        });
    },
    SET_PROGRAMS: (state, payload) => {
        state.programs = payload;
    },
    SET_CURRENT_PROGRAM: (state, payload) => {
        state.currentProgram = payload;
    },
    SET_CURRENT_STUDENT: (state, payload) => {
        state.currentStudent = payload;
    },
    SET_CURRENT_INSTRUCTOR: (state, payload) => {
        state.currentInstructor = payload;
    },
    SET_INSTRUCTORS: (state, payload) => {
        state.instructors = payload;
    },
    SET_MOCK_STUDENTS: (state, payload) => {
        state.mockStudents = payload;
    },
    SET_STUDENTS: (state, payload) => {
        state.students = payload;
    },
    SET_PROGRAM_INSTRUCTORS: (state, payload) => {
        state.programInstructors = payload;
    },

    SET_LOADING: (state, payload) => {
        state.loading = payload;
    },
    SET_DATA_LOADING: (state, payload) => {
        state.dataLoading = payload;
    },
    SET_SECTION_LOADING: (state, { section, value }) => {
        state.sectionLoading[section] = value;
    },
    SET_INSTRUCTOR_SESSION_STUDENTS: (state, payload) => {
        state.instructorSessionStudents = payload;
    },
    SET_PROGRAM_STUDENTS: (state, payload) => {
        state.programStudents = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
